var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ljBG9urpL8MBL7GYJMK_y"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["accred-frontend@uniqsoft"]={id:"ljBG9urpL8MBL7GYJMK_y"};
      